var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.889,
    height: 153.888,
    viewBox: "0 0 153.889 153.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.213,
    y1: 0.257,
    x2: 0.681,
    y2: 1.068,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26326",
    "data-name": "Group 26326",
    transform: "translate(18307.441 -1028.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26263",
    "data-name": "Group 26263",
    transform: "translate(-18307.441 1028.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18588",
    "data-name": "Path 18588",
    d: "M76.944,0A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18588_-_Outline",
    "data-name": "Path 18588 - Outline",
    d: "M76.944,6.318A70.627,70.627,0,0,0,27,126.885,70.627,70.627,0,1,0,126.885,27,70.164,70.164,0,0,0,76.944,6.318m0-6.318A76.944,76.944,0,1,1,0,76.944,76.944,76.944,0,0,1,76.944,0Z",
    transform: "translate(0 0)",
    fill: "#ffd055"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(-18264.256 1071.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M16.087,32.182a4.788,4.788,0,0,1-3.411-1.416L1.414,19.5a4.828,4.828,0,0,1,0-6.828L12.676,1.414A4.828,4.828,0,1,1,19.5,8.242l-7.851,7.851L19.5,23.945a4.823,4.823,0,0,1-3.417,8.237Z",
    transform: "translate(1.581 1.579)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10107_-_Outline",
    "data-name": "Path 10107 - Outline",
    d: "M17.416,35.091a6.341,6.341,0,0,1-4.531-1.882L1.627,21.95a6.407,6.407,0,0,1,0-9.062L12.889,1.627a6.408,6.408,0,1,1,9.062,9.062l-6.734,6.734,6.734,6.734a6.4,6.4,0,0,1-4.534,10.934Zm0-32.182a3.228,3.228,0,0,0-2.3.952L3.86,15.122a3.248,3.248,0,0,0,0,4.594L15.122,30.979a3.207,3.207,0,0,0,2.294.953,3.245,3.245,0,0,0,2.3-5.541l-8.968-8.968,8.968-8.968a3.249,3.249,0,0,0-2.3-5.546Z",
    transform: "translate(0.252 0.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M57.918,9.653H4.827A4.827,4.827,0,0,1,4.827,0H57.918a4.827,4.827,0,0,1,0,9.653Z",
    transform: "translate(3.188 12.846)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108_-_Outline",
    "data-name": "Path 10108 - Outline",
    d: "M59.248,12.562H6.156a6.406,6.406,0,0,1,0-12.812H59.248a6.406,6.406,0,0,1,0,12.812ZM6.156,2.909a3.247,3.247,0,0,0,0,6.494H59.248a3.247,3.247,0,0,0,0-6.494Z",
    transform: "translate(1.859 11.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M4.825,32.188a4.83,4.83,0,0,1-3.411-8.244l7.851-7.851L1.414,8.242A4.828,4.828,0,0,1,8.242,1.414L19.5,12.676a4.828,4.828,0,0,1,0,6.828L8.242,30.766A4.794,4.794,0,0,1,4.825,32.188Z",
    transform: "translate(45.02 33.75)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10109_-_Outline",
    "data-name": "Path 10109 - Outline",
    d: "M6.152,35.1a6.341,6.341,0,0,1-4.531-1.882,6.414,6.414,0,0,1,0-9.058l6.734-6.734L1.625,10.688a6.408,6.408,0,1,1,9.062-9.062L21.948,12.889a6.415,6.415,0,0,1,0,9.062L10.686,33.212A6.349,6.349,0,0,1,6.152,35.1Zm0-32.188a3.249,3.249,0,0,0-2.3,5.546l8.968,8.968L3.858,26.391a3.252,3.252,0,0,0,0,4.594,3.237,3.237,0,0,0,4.59,0L19.714,19.717a3.252,3.252,0,0,0,0-4.594L8.452,3.86A3.227,3.227,0,0,0,6.155,2.909Z",
    transform: "translate(43.693 32.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M57.918,9.653H4.827A4.827,4.827,0,0,1,4.827,0H57.918a4.827,4.827,0,0,1,0,9.653Z",
    transform: "translate(1.579 45.023)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10110_-_Outline",
    "data-name": "Path 10110 - Outline",
    d: "M59.248,12.562H6.156a6.406,6.406,0,0,1,0-12.812H59.248a6.406,6.406,0,0,1,0,12.812ZM6.156,2.909a3.247,3.247,0,0,0,0,6.494H59.248a3.247,3.247,0,0,0,0-6.494Z",
    transform: "translate(0.25 43.694)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralTransfer);
export default __webpack_public_path__ + "static/media/general-transfer.0f40b00f399b08d292ef9b834d62c1dc.svg";
export { ForwardRef as ReactComponent };